import React, { useState, useContext } from 'react';
import { Context } from '../../services/contexts/StateContext';
import * as S from './styles';

const CATEGORIAS_ARQUIVOS = [
    'CHASSI',
    'FRENTE_DIR',
    'FRENTE_ESQ',
    'FUNDO_DIR',
    'FUNDO_ESQ',
    'MOTOR',
    'PAINEL',
    'KM PAINEL',
    'SELFIE',
    'VIDEOS'
];

const CATEGORIA_ICONES = {
    CHASSI: 'CH',
    FRENTE_DIR: 'FD',
    FRENTE_ESQ: 'FE',
    FUNDO_DIR: 'TD',
    FUNDO_ESQ: 'TE',
    MOTOR: 'MT',
    PAINEL: 'PN',
    'KM PAINEL': 'KM',
    SELFIE: 'SF',
    VIDEOS: 'VD',
    OUTROS: 'OT'
};

const S3_BASE_URL = 'https://rbento-web.s3.us-east-1.amazonaws.com/';

const extrairCaminhoArquivo = (arquivo) => {
    if (!arquivo) return '';

    if (typeof arquivo === 'string') {
        return arquivo.trim();
    }

    if (typeof arquivo === 'object') {
        return (
            arquivo.arquivo ||
            arquivo.path ||
            arquivo.key ||
            arquivo.url ||
            arquivo.location ||
            arquivo.src ||
            ''
        ).toString().trim();
    }

    return '';
};

const normalizarListaArquivos = (entrada) => {
    const listaBase = Array.isArray(entrada) ? entrada : (entrada ? [entrada] : []);

    return listaBase
        .flatMap((item) => {
            if (!item) return [];
            if (Array.isArray(item)) return item;
            if (typeof item === 'object' && Array.isArray(item.arquivos)) return item.arquivos;
            return [item];
        })
        .map(extrairCaminhoArquivo)
        .filter(Boolean);
};

const montarUrlArquivo = (arquivo = '') => {
    if (!arquivo) return '';
    if (/^https?:\/\//i.test(arquivo)) return arquivo;
    return `${S3_BASE_URL}${arquivo.replace(/^\/+/, '')}`;
};

const obterNomeArquivo = (arquivo = '') => {
    const semQuery = arquivo.split('?')[0];
    const nome = semQuery.split('/').pop() || semQuery;
    return decodeURIComponent(nome);
};

const normalizarTexto = (texto = '') => texto
    .toUpperCase()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .replace(/[._-]+/g, ' ')
    .replace(/\s+/g, ' ')
    .trim();

const ehVideo = (arquivo = '') => /\.mp4$/i.test(arquivo) || normalizarTexto(obterNomeArquivo(arquivo)).includes('VIDEO');

const obterCategoriaArquivo = (arquivo = '') => {
    if (ehVideo(arquivo)) {
        return 'VIDEOS';
    }

    const nomeNormalizado = normalizarTexto(obterNomeArquivo(arquivo));
    const categoriaEncontrada = CATEGORIAS_ARQUIVOS.find((categoria) => (
        categoria !== 'VIDEOS' && nomeNormalizado.includes(normalizarTexto(categoria))
    ));

    return categoriaEncontrada || 'OUTROS';
};

const ordenarArquivosPorNome = (arquivoA, arquivoB) => (
    obterNomeArquivo(arquivoA).localeCompare(obterNomeArquivo(arquivoB), 'pt-BR', {
        numeric: true,
        sensitivity: 'base'
    })
);

const estilos = {
    tituloPrincipal: {
        color: '#143d2f',
        marginBottom: '10px',
        fontSize: '15px',
        fontWeight: 'bold'
    },
    blocoCategoria: {
        width: '100%',
        marginTop: '16px',
        padding: '14px 12px 16px',
        borderRadius: '12px',
        border: '1px solid #d6e8dd',
        background: 'linear-gradient(180deg, #ffffff 0%, #f2f8f4 100%)',
        boxShadow: '0 8px 18px rgba(22, 61, 44, 0.09)'
    },
    cabecalhoCategoria: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        gap: '10px',
        marginBottom: '12px',
        paddingBottom: '8px',
        borderBottom: '1px solid #dbe9e1'
    },
    tituloCategoria: {
        color: '#1f4d39',
        display: 'block',
        fontSize: '13px',
        fontWeight: 'bold',
        letterSpacing: '0.6px',
        textTransform: 'uppercase'
    },
    badgeQuantidade: {
        minWidth: '28px',
        padding: '3px 8px',
        borderRadius: '999px',
        backgroundColor: '#e6f4ec',
        border: '1px solid #b7dbc5',
        color: '#1f6d47',
        fontSize: '11px',
        fontWeight: 'bold',
        textAlign: 'center'
    },
    listaArquivos: {
        display: 'flex',
        gap: '12px',
        flexWrap: 'nowrap',
        justifyContent: 'flex-start',
        overflowX: 'auto',
        paddingBottom: '6px'
    },
    barraCategorias: {
        display: 'flex',
        width: '100%',
        gap: '8px',
        overflowX: 'auto',
        paddingBottom: '4px',
        marginBottom: '12px'
    },
    botaoCategoria: {
        display: 'flex',
        alignItems: 'center',
        gap: '8px',
        borderRadius: '999px',
        border: '1px solid #cfe2d6',
        background: '#ffffff',
        color: '#1d4a36',
        padding: '7px 10px',
        fontSize: '12px',
        fontWeight: 700,
        cursor: 'pointer',
        whiteSpace: 'nowrap'
    },
    iconeCategoria: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: '24px',
        height: '24px',
        borderRadius: '999px',
        background: '#e9f4ee',
        color: '#1f6d47',
        fontSize: '10px',
        fontWeight: 800,
        border: '1px solid #c4dece'
    },
    cardArquivo: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        cursor: 'pointer',
        position: 'relative',
        width: '110px',
        padding: '8px',
        borderRadius: '10px',
        backgroundColor: '#ffffff',
        border: '1px solid #d8e8df',
        transition: 'transform 0.2s ease, border-color 0.2s ease'
    },
    midiaBox: {
        width: '100px',
        height: '100px',
        backgroundColor: '#f0f5f2',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        borderRadius: '8px',
        border: '1px solid #c8ddd0',
        position: 'relative',
        overflow: 'hidden'
    },
    nomeArquivo: {
        fontSize: '11px',
        marginTop: '7px',
        color: '#244737',
        textAlign: 'center',
        maxWidth: '100px',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        fontWeight: 'bold'
    }
};

//----------------------------------------------------
export function ExibirArquivosS3ListaVistoria({ arqVistoria }) {
    const { state } = useContext(Context);
    const { evento } = state.evento;
    const arquivosEntrada = arqVistoria || evento.arquivos || [];
    const arquivosFonte = normalizarListaArquivos(arquivosEntrada);

    const [arquivoSelecionado, setArquivoSelecionado] = useState(null);
    const [tipoArquivo, setTipoArquivo] = useState('');
    const [isVideoBlob, setIsVideoBlob] = useState(false);
    const [loadingArquivo, setLoadingArquivo] = useState(false);
    const [categoriaSelecionada, setCategoriaSelecionada] = useState('');

    // Funcao para abrir arquivo em tela cheia
    const abrirArquivo = async (arquivo) => {
        const urlCompleta = montarUrlArquivo(arquivo);

        // Verificar se e video
        if (/\.mp4$/i.test(arquivo) || /video/i.test(arquivo)) {
            setTipoArquivo('video');

            try {
                setLoadingArquivo(true);
                const resposta = await fetch(urlCompleta, { cache: 'no-store' });

                if (!resposta.ok) {
                    throw new Error('Falha ao carregar video');
                }

                const videoBlob = await resposta.blob();
                const blobUrl = URL.createObjectURL(videoBlob);

                setIsVideoBlob(true);
                setArquivoSelecionado(blobUrl);
            } catch (error) {
                // Fallback para URL direta caso blob falhe.
                setIsVideoBlob(false);
                setArquivoSelecionado(urlCompleta);
            } finally {
                setLoadingArquivo(false);
            }
        } else {
            setTipoArquivo('imagem');
            setIsVideoBlob(false);
            setArquivoSelecionado(urlCompleta);
        }
    };

    // Funcao para fechar visualizacao
    const fecharVisualizacao = () => {
        if (isVideoBlob && arquivoSelecionado) {
            URL.revokeObjectURL(arquivoSelecionado);
        }

        setArquivoSelecionado(null);
        setTipoArquivo('');
        setIsVideoBlob(false);
        setLoadingArquivo(false);
    };

    // Se nao houver arquivos, nao exibir nada
    if (!arquivosFonte || arquivosFonte.length === 0) {
        return null;
    }

    const arquivosOrdenados = [...arquivosFonte].sort(ordenarArquivosPorNome);
    const arquivosAgrupados = arquivosOrdenados.reduce((grupos, arquivo) => {
        const categoria = obterCategoriaArquivo(arquivo);

        if (!grupos[categoria]) {
            grupos[categoria] = [];
        }

        grupos[categoria].push(arquivo);

        return grupos;
    }, {});

    const categoriasParaExibir = [
        ...CATEGORIAS_ARQUIVOS.filter((categoria) => arquivosAgrupados[categoria]?.length),
        ...Object.keys(arquivosAgrupados).filter((categoria) => (
            categoria !== 'OUTROS' && !CATEGORIAS_ARQUIVOS.includes(categoria)
        )),
        ...(arquivosAgrupados.OUTROS?.length ? ['OUTROS'] : [])
    ];

    const categoriaAtiva = categoriasParaExibir.includes(categoriaSelecionada)
        ? categoriaSelecionada
        : (categoriasParaExibir[0] || '');

    const arquivosCategoriaAtiva = categoriaAtiva ? (arquivosAgrupados[categoriaAtiva] || []) : [];

    return (
        <>
            <S.Arquivos>
                <span style={estilos.tituloPrincipal}>
                    Arquivos Salvos ({arquivosFonte.length})
                </span>

                <div style={{ width: '100%', maxHeight: '460px', overflowY: 'auto', paddingRight: '4px' }}>
                <div style={estilos.barraCategorias}>
                    {categoriasParaExibir.map((categoria) => {
                        const ativa = categoria === categoriaAtiva;
                        return (
                            <button
                                key={categoria}
                                type='button'
                                onClick={() => setCategoriaSelecionada(categoria)}
                                style={{
                                    ...estilos.botaoCategoria,
                                    background: ativa ? '#1f6d47' : estilos.botaoCategoria.background,
                                    color: ativa ? '#ffffff' : estilos.botaoCategoria.color,
                                    border: ativa ? '1px solid #1f6d47' : estilos.botaoCategoria.border,
                                }}
                            >
                                <span
                                    style={{
                                        ...estilos.iconeCategoria,
                                        background: ativa ? '#2f845a' : estilos.iconeCategoria.background,
                                        color: ativa ? '#ffffff' : estilos.iconeCategoria.color,
                                        border: ativa ? '1px solid #2f845a' : estilos.iconeCategoria.border,
                                    }}
                                >
                                    {CATEGORIA_ICONES[categoria] || 'OT'}
                                </span>
                                {categoria}
                                <span style={{ fontSize: '11px', opacity: 0.9 }}>({arquivosAgrupados[categoria]?.length || 0})</span>
                            </button>
                        );
                    })}
                </div>

                {categoriaAtiva && (
                    <div key={categoriaAtiva} style={estilos.blocoCategoria}>
                        <div style={estilos.cabecalhoCategoria}>
                            <span style={estilos.tituloCategoria}>
                                {categoriaAtiva === 'VIDEOS' ? 'Videos' : categoriaAtiva}
                            </span>
                            <span style={estilos.badgeQuantidade}>
                                {arquivosCategoriaAtiva.length}
                            </span>
                        </div>

                        <div style={estilos.listaArquivos}>
                            {arquivosCategoriaAtiva.map((arq, index) => {
                                const urlCompleta = montarUrlArquivo(arq);
                                const isVideo = ehVideo(arq);

                                return (
                                    <div
                                        key={`${categoriaAtiva}-${arq}-${index}`}
                                        style={estilos.cardArquivo}
                                        onClick={() => abrirArquivo(arq)}
                                    >
                                        {isVideo ? (
                                            <div style={estilos.midiaBox}>
                                                <div
                                                    style={{
                                                        width: '100%',
                                                        height: '100%',
                                                        objectFit: 'cover',
                                                        borderRadius: '8px',
                                                        display: 'flex',
                                                        alignItems: 'center',
                                                        justifyContent: 'center',
                                                        background: 'linear-gradient(135deg, #1f2d3a 0%, #0a1117 100%)',
                                                        color: '#ffffff',
                                                        fontSize: '12px',
                                                        fontWeight: 'bold'
                                                    }}
                                                >
                                                    VIDEO
                                                </div>
                                                <div style={{
                                                    position: 'absolute',
                                                    fontSize: '30px',
                                                    color: '#ffffff',
                                                    textShadow: '0 0 4px rgba(0,0,0,0.6)'
                                                }}>
                                                    ▶
                                                </div>
                                            </div>
                                        ) : (
                                            <img
                                                src={urlCompleta}
                                                alt={`Arquivo ${index + 1}`}
                                                style={{
                                                    width: '100px',
                                                    height: '100px',
                                                    objectFit: 'cover',
                                                    borderRadius: '8px',
                                                    border: '1px solid #c8ddd0'
                                                }}
                                            />
                                        )}
                                        <span style={estilos.nomeArquivo}>
                                            {obterNomeArquivo(arq)}
                                        </span>
                                    </div>
                                );
                            })}
                        </div>
                    </div>
                )}
                </div>
            </S.Arquivos>

            {(arquivoSelecionado || loadingArquivo) && (
                <S.Play>
                    <S.BoxPlay>
                        {loadingArquivo && (
                            <div style={{ color: '#ffffff', fontWeight: 'bold' }}>
                                Carregando arquivo...
                            </div>
                        )}

                        {!loadingArquivo && tipoArquivo === 'video' ? (
                            <video
                                src={arquivoSelecionado}
                                controls
                                autoPlay
                                preload='metadata'
                                style={{
                                    maxWidth: '90vw',
                                    maxHeight: '80vh',
                                    borderRadius: '10px'
                                }}
                            />
                        ) : (
                            <img
                                src={arquivoSelecionado}
                                alt='Visualizacao'
                                style={{
                                    maxWidth: '90vw',
                                    maxHeight: '80vh',
                                    borderRadius: '10px',
                                    objectFit: 'contain'
                                }}
                            />
                        )}

                        <button
                            onClick={fecharVisualizacao}
                            style={{
                                marginTop: '20px',
                                padding: '10px 30px',
                                fontSize: '16px',
                                fontWeight: 'bold',
                                backgroundColor: '#f0433d',
                                color: 'white',
                                border: 'none',
                                borderRadius: '5px',
                                cursor: 'pointer'
                            }}
                        >
                            X FECHAR
                        </button>
                    </S.BoxPlay>
                </S.Play>
            )}
        </>
    );
}
